import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { locationsSelector } from '../../../../store/slices/location'
import {Box, Checkbox, FormControl, FormControlLabel, MenuItem, Select, Stack, styled, TextField, Typography} from '@mui/material'
import _ from 'lodash'
import { RFC_2822 } from 'moment'
export const RESPONDER_SETTINGS='rSettings';
export const Section=styled(Box)(({ theme }) => ({
    position:'relative',
    padding:theme.spacing(2),
    borderRadius:'6px',
    border:'1px solid',
    borderColor:theme.palette.divider,
  }));
  export const SectionHeaderText=styled(Typography)(({ theme }) => ({
    position:'absolute',
    padding:'0 4px 0 4px',
    top:-10,
    left:16,
    backgroundColor:theme.palette.background.paper,
    color:theme.palette.text.secondary
  }));
  const greetingList=[{id:1,text:'[Name Only]'},{id:2,text:'Hi'},{id:3,text:'Hello'},{id:4,text:'Dear Customer'}]
const Settings = ({companyId}) => {
    const {responderSettings}=useSelector(locationsSelector)
    const [greetingText,setGreetingText]=useState('')
    const [businessName,setBusinessName]=useState('')
    const [contactInfo,setContactInfo]=useState('')
    const [contactPhrase,setContactPhrase]=useState('')
    const [reviewerName,setReviewerName]=useState('')
    const [closing,setClosing]=useState('')
    const [newParagraph,setNewParagraph]=useState({greeting:false,closing:false})
    const responderSettingsMemo=useMemo(()=>{
        const groupedData=_.groupBy(responderSettings,'key')
        if(_.isEmpty(groupedData))return {Greeting:[]}
        const greeting=_.map(groupedData['Greeting']??[],it=>{
            const parsedData=JSON.parse(it?.data)?JSON.parse(it?.data):null
            if(parsedData) return ({...it,...parsedData})
                return ({...it})
        })
        return ({...groupedData,['Greeting']:greeting})
    },[responderSettings])
    const greetingsDropDownData=useMemo(()=>{
        if(_.isEmpty(responderSettingsMemo['Greeting']))return []
        const listData=[...responderSettingsMemo['Greeting']??[]]
        const finalData=_.flatMap(listData,a=>{
            let arr=[]
            arr.push(...a?.Greeting?.WithName?.Data??[])
            arr.push(...a?.Greeting?.WithoutName?.Data??[])
            return (arr)
        })
        return _.uniqBy(finalData,'text')
    },[responderSettingsMemo])
    const handleTextSetting=(val,name,returnFn,isName)=>{
        const localStorageItem=localStorage.getItem(RESPONDER_SETTINGS)
        if(localStorageItem){
            const selectedCompanyItem=JSON.parse(localStorageItem)[companyId]
            const prevData=selectedCompanyItem?.[name]??{}
            const returnItem={...selectedCompanyItem,[name]:{...prevData}}
            if(!isName){
                returnItem[name]['text']=val
            }
            if(greetingText==='[Name Only]'){
                returnItem[name]['default']=true
            }
            else {
                returnItem[name]['default']=false
            }
             if(isName) {
                returnItem[name]['additionalText']=val
            }
            localStorage.setItem(RESPONDER_SETTINGS,JSON.stringify({...JSON.parse(localStorageItem),[companyId]:returnItem}))
        }
        else{
            const rItem={paragraph:false}
            if(greetingText==='[Name Only]'){
                rItem['default']=true
            }
            else {
                rItem['default']=false
            }
            if(!isName){
                rItem['text']=val
            }
             if(isName) {
                rItem['additionalText']=val
            }
            localStorage.setItem(RESPONDER_SETTINGS,JSON.stringify({[companyId]:{[name]:rItem}}))
        }
        if(returnFn){
            returnFn(val)
        }
    }
    useEffect(()=>{
        if(!companyId) return
        const localStorageData=localStorage.getItem(RESPONDER_SETTINGS)
        if(!localStorageData)return
        const parsedData=JSON.parse(localStorageData)??null
        if(!parsedData)return
        const companyData=parsedData[companyId]
        if(!companyData)return
        const greetingData=companyData['Greeting']
        if(greetingData){
            if(greetingData?.text){
                const detectedData=_.find(greetingList,a=>a.text===greetingData?.text)
                if(detectedData){
                    setGreetingText(greetingData?.text??'')
                    if(greetingData?.additionalText)
                    setReviewerName(greetingData?.additionalText??'')
                }
            }
            if(greetingData?.paragraph){
                setNewParagraph(prev=>({...prev,greeting:true}))
            }
        }
        const closingData=companyData['Closing']
        if(closingData){
            if(closingData?.text){
                setClosing(closingData?.text??'')
            }
            if(closingData?.paragraph){
                setNewParagraph(prev=>({...prev,closing:true}))
            }
        }
        const businessData=companyData['BusinessName']
        if(businessData?.text){
            setBusinessName(businessData?.text)
        }
        const contactInfo=companyData['ContactInfo']
        if(contactInfo?.text){
            setContactInfo(contactInfo.text)
        }
        const contactPhrase=companyData['ContactPhrase']
        if(contactPhrase?.text){
            setContactPhrase(contactPhrase.text)
        }

    },[companyId])
    const handleCheckboxChange=(val,name)=>{
        const localStorageItem=localStorage.getItem(RESPONDER_SETTINGS)
        if(localStorageItem){
            const selectedCompanyItem=JSON.parse(localStorageItem)[companyId]
            const prevData=selectedCompanyItem[name]??{}
            const returnItem={...selectedCompanyItem,[name]:{...prevData,paragraph:val}}
            localStorage.setItem(RESPONDER_SETTINGS,JSON.stringify({...JSON.parse(localStorageItem),[companyId]:returnItem}))
        }
        else{
            localStorage.setItem(RESPONDER_SETTINGS,JSON.stringify({[companyId]:{[name]:{paragraph:val,text:''}}}))
        } 
        const lowerCaseName=_.toLower(name)
        setNewParagraph(prev=>({...prev,[lowerCaseName]:val}))
    }
  return (
    <Stack spacing={2} sx={{pt:2,maxHeight:'calc(100vh - 150px)',overflowY:'auto'}}>
        <Section>
        <Stack direction='row' alignItems={'center'} spacing={3}>
            <Select name='Greeting' size='small' sx={{width:'200px'}} value={greetingText} onChange={e=>handleTextSetting(e.target.value,e.target.name,setGreetingText)}>
            {_.map(greetingList,a=><MenuItem value={a.text} key={a.id}>{a.text}</MenuItem>)}
            </Select>
            {<TextField size='small' name='Greeting' value={reviewerName} sx={{minWidth:'200px'}} onChange={e=>handleTextSetting(e.target.value,e.target.name,setReviewerName,true)}/>}
        </Stack>
        <FormControlLabel label='Place greeting in a new paragraph' control={<Checkbox checked={newParagraph.greeting} name='Greeting' onChange={e=>handleCheckboxChange(e.target.checked,e.target.name)} size='small'/>}/>
       <SectionHeaderText variant='caption'>Greeting</SectionHeaderText> 
        </Section>
        <Section>
        <Stack direction='row' alignItems={'center'} spacing={3}>
            {<TextField size='small' multiline maxRows={3} value={closing} sx={{minWidth:'300px'}} name='Closing' onChange={e=>handleTextSetting(e.target.value,e.target.name,setClosing)}/>}
        </Stack>
        <FormControlLabel label='Place greeting in a new paragraph' control={<Checkbox checked={newParagraph.closing} name='Closing' onChange={e=>handleCheckboxChange(e.target.checked,e.target.name)} size='small'/>}/>
       <SectionHeaderText variant='caption'>Closing</SectionHeaderText> 
        </Section>
        <Section>
        <Stack direction='row' alignItems={'center'} spacing={3}>
            {<TextField size='small' value={businessName} sx={{minWidth:'300px'}} name='BusinessName' onChange={e=>handleTextSetting(e.target.value,e.target.name,setBusinessName)}/>}
        </Stack>
       <SectionHeaderText variant='caption'>Business Name</SectionHeaderText> 
        </Section>
        <Section>
        <Stack spacing={2} pb={2}>
            <Typography flexShrink={0}>How to contact (email or phone #, etc.) the company?</Typography>
            {<TextField size='small' sx={{maxWidth:'600px'}}  value={contactInfo} fullWidth  name='ContactInfo' onChange={e=>handleTextSetting(e.target.value,e.target.name,setContactInfo)}/>}
        </Stack>
        <Stack spacing={2}>
            <Typography flexShrink={0} noWrap>What text/contact would you like to inform the Response?</Typography>
            {<TextField size='small'sx={{maxWidth:'600px'}}  value={contactPhrase} fullWidth name='ContactPhrase' onChange={e=>handleTextSetting(e.target.value,e.target.name,setContactPhrase)}/>}
        </Stack>
       <SectionHeaderText variant='caption'>Contact Info</SectionHeaderText> 
        </Section>
        
    </Stack>
  )
}

export default Settings